
import { setMetaRobots } from '@/utils/utils'

export default {
  name: 'PrivacyCommon',
  head() {
    return {
      title: this.$t('home.footer.store') + ' - ' + this.$t('home.title'),
      meta: [
        setMetaRobots(false)
      ]
    }
  },
  mounted() {
    document.title = this.$t('home.title')
  }
}
